module.exports = __webpack_public_path__ + "static/media/6.d53e8c2e.jpg";